import React, { useState, useEffect } from "react";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";

const ProductImageSlider = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxIndex = Math.max(images.length - 1, 0);

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  return (
    <div className="relative max-w-sm mx-auto md:mx-0">
      <img
        src={images[currentIndex]?.path}
        alt={`Product ${currentIndex + 1}`}
        className="w-full h-72 object-contain bg-white"
      />

      {/* Tombol kiri-kanan selalu muncul jika ada lebih dari 1 gambar */}
      {images.length > 1 && (
        <>
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-[#5c4033] text-white p-1 rounded-full z-10 disabled:opacity-40"
          >
            <ArrowLeft2 size={isMobile ? 16 : 20} color="#fff" />
          </button>
          <button
            onClick={handleNext}
            disabled={currentIndex === maxIndex}
            className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-[#5c4033] text-white p-1 rounded-full z-10 disabled:opacity-40"
          >
            <ArrowRight2 size={isMobile ? 16 : 20} color="#fff" />
          </button>
        </>
      )}

      {/* Dot indikator */}
      {images.length > 1 && (
        <div className="flex justify-center mt-2 gap-1">
          {images.map((_, i) => (
            <div
              key={i}
              className={`w-2 h-2 rounded-full ${
                i === currentIndex ? "bg-[#5c4033]" : "bg-gray-300"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductImageSlider;
